import { IGoal } from 'motw_core/Entity/IGoal';
import { IGoalDataPoint } from 'motw_core/Entity/IGoalDataPoint';
import { ILogEntry } from 'motw_core/Entity/ILogEntry';
import Data from '../Data';
import { DeleteDatapointAsync } from 'motw_core/Repositories/DatapointRepository';
import { DeleteLogEntryAsync } from 'motw_core/Repositories/LogRepository';
import ClientDataProvider from 'source/app/services/External/ClientDataProvider/ClientDataProvider';

export async function RemoveDatapointAsync(
	goal: IGoal,
	connectedLogEntry: ILogEntry,
	datapoint: IGoalDataPoint
) {
	await DeleteLogEntryAsync(connectedLogEntry.id, ClientDataProvider);
	await DeleteDatapointAsync(goal.name, datapoint.id, ClientDataProvider);
	await Data.Load.AllAsync();
}
